import React from 'react'

import { IBulletPoint } from '@interfaces/components/atoms/BulletPoint'

const BulletPoint: React.FC<IBulletPoint> = ({
  text,
  bulletPointText = '•',
  separator = 5,
  className,
  textClassName,
}) => {
  return (
    <div className={`d-flex ${className}`}>
      <div className={textClassName} style={{ marginRight: separator }}>
        {bulletPointText}
      </div>
      <div className={textClassName}>{text}</div>
    </div>
  )
}

export default BulletPoint
